// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"799":"96eb96ef","900":"9b37469b","964":"96eb96ef"}[chunkId] + ".chunk.css";
};